<h2 mat-dialog-title>{{ data.title }}</h2>
<div mat-dialog-content>
    <p>
        {{ data.description }} <b>{{ $totalCount() }}</b> configurations.
    </p>
    @if (data.unassignedCount > 0) {
        <mat-checkbox [checked]="$includeUnassigned()" (change)="$includeUnassigned.set($event.checked)">
            Include {{ data.unassignedCount }} unassigned render{{ data.unassignedCount === 1 ? "" : "s" }}
        </mat-checkbox>
    }
    <p>Are you sure you want to continue?</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button [color]="data.destructive ? 'warn' : 'primary'" (click)="confirmAction()" [disabled]="$totalCount() === 0">
        {{ data.confirmLabel }}
    </button>
    <button mat-button (click)="cancelAction()" autofocus>Cancel</button>
</div>
